// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2F2Qp","footer":"styles_footer__2_4aK"};